<template>
  <v-layout
    justify-start
    class="px-12"
    style="position: absolute; left: 0; right: 0; bottom: 0; top: 0; overflow-y: auto;"
  >
    <v-col cols="3">
      <my-tasks></my-tasks>
    </v-col>
    <v-col>
      <v-layout column>
        <my-contexts class="my-4"></my-contexts>
        <my-resources></my-resources>
      </v-layout>
    </v-col>
  </v-layout>
</template>

<script>
import MyContexts from './MyContexts';
import MyResources from './MyResources';
import MyTasks from './MyTasks';

export default {
  components: { MyContexts, MyResources, MyTasks }
};
</script>
